/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierStarterAiEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_STARTER_AI_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierStarterAiEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierStarterAiEnabledSettingParser.decode(input).map(res => new TierStarterAiEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierStarterAiEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierStarterAiEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierStarterAiEnabledSettingParser.schema();
    }
}
